var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ApiTable,{attrs:{"scene":"enterprise_customer_info_v2","params":_setup.params},on:{"message":_setup.handleMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }